import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from 'seagull';
import { RichTextViewer } from 'seagull/components/RichTextViewer';
import styles from './QuillViewerModal.module.scss';
export const QuillViewerModal = (props)=>{
    const { title, value, onClose, testId } = props;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'quill_viewer_confirm'
            },
            secondaryButton: {
                name: 'quill_viewer_cancel'
            }
        },
        overflowContent: true,
        contentPadding: "small",
        width: "800px",
        height: "calc(100% - 128px)",
        title: title,
        onCloseButtonClick: onClose,
        testId: testId,
        content: /*#__PURE__*/ _jsx("div", {
            className: styles.quillViewerContainer,
            children: /*#__PURE__*/ _jsx(RichTextViewer, {
                value: value
            })
        })
    });
};
